import * as React from 'react';
import {
  TextField,
  TextFieldProps,
  withStyles,
} from '@material-ui/core';

const TextInput = ({
  variant = 'outlined',
  ...props
}: TextFieldProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Input variant={variant} {...props} />
);

const Input = withStyles({
  root: {
    backgroundColor: 'var(--neutral-0)',
    borderRadius: 'var(--radius-md)',
    fontFamily: 'inherit',

    '& legend > span': {
      display: 'none',
    },
    '& .MuiOutlinedInput-notchedOutline legend': {
      display: 'none',
    },
    '& .MuiInputBase-root': {
      borderRadius: 'var(--radius-md)',
      fontSize: 'var(--fs-base)',
      color: 'var(--neutral-800)',
      height: '40px',
      transition:
        'box-shadow var(--motion-fast) var(--ease-standard), border-color var(--motion-fast) var(--ease-standard)',
    },
    '& .MuiInputBase-multiline': {
      height: 'auto',
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 12px',
      border: 0,
      outline: 0,
      background: 'transparent',
      boxShadow: 'none',
    },
    '& .MuiOutlinedInput-input:focus': {
      outline: 0,
      boxShadow: 'none',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--neutral-300)',
      top: 0,
    },
    '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--neutral-400)',
    },
    '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--primary-600)',
      borderWidth: '1px',
      boxShadow: 'var(--shadow-focus)',
    },
    '& .MuiInputBase-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--danger-500)',
    },
    '& .MuiInputBase-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
      boxShadow: 'var(--shadow-focus-danger)',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: 'var(--neutral-100)',
      color: 'var(--neutral-500)',
    },
    '& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--neutral-200)',
    },
    '& .MuiInputBase-root:has(input[readonly]), & .MuiInputBase-root:has(textarea[readonly])': {
      backgroundColor: 'var(--neutral-100)',
      color: 'var(--neutral-500)',
      cursor: 'not-allowed',
    },
    '& .MuiInputBase-root:has(input[readonly]) .MuiOutlinedInput-notchedOutline, & .MuiInputBase-root:has(textarea[readonly]) .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--neutral-200)',
    },
    '& .MuiInputBase-root:has(input[readonly]):hover .MuiOutlinedInput-notchedOutline, & .MuiInputBase-root:has(textarea[readonly]):hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--neutral-200)',
    },
    '& .MuiInputBase-root.Mui-focused:has(input[readonly]) .MuiOutlinedInput-notchedOutline, & .MuiInputBase-root.Mui-focused:has(textarea[readonly]) .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--neutral-200)',
      boxShadow: 'none',
    },
    '& input[readonly], & textarea[readonly]': {
      cursor: 'not-allowed',
      color: 'var(--neutral-500)',
    },
    '& .MuiInputLabel-animated': {
      transition: 'none',
      animation: 'none',
    },
    '& .MuiFormLabel-filled': {
      display: 'none',
    },
    '& .MuiFormLabel-root.Mui-focused': {
      display: 'none',
    },
    '& .MuiFormHelperText-root': {
      fontFamily: 'inherit',
      fontSize: 'var(--fs-sm)',
      marginTop: '4px',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: 'var(--danger-600)',
    },
  },
})(TextField);

export default TextInput;
